import APIClient from '@/shared/http/clients/api'

const resourceName = 'origemlead'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nome,asc&size=500`, data, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?inative=0&sort=nome,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&sort=inative,asc&sort=nome,asc`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
function buildSearchParams (filters, limit, index) {
  const params = new URLSearchParams()
  params.append('page', index)
  params.append('size', limit)
  params.append('sort', 'inative,asc')
  params.append('sort', 'nome,asc')
  if (filters.nome) params.append('nome', filters.nome)
  if (filters.inative === 0 || filters.inative === 1) params.append('inative', filters.inative)
  return params.toString()
}
const Search = (filters = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${buildSearchParams(filters, limit, index)}`, config)

const OriginRepository = {
  GetAll,
  GetAllActive,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  ChangeStatus,
  Search
}

export default OriginRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/origin.js